/** Filtre discovery « Pro adhérent MFEC » — URL partageable + GET /search/pros. */

export const DISCOVERY_MFEC_URL_PARAM = 'pro_adherent';
export const DISCOVERY_MFEC_PARTNER_SLUG = 'mfec';

const TRUTHY = new Set(['1', 'true', 'yes', 'on']);

export function discoveryMfecFilterActive(searchOrParams: string | URLSearchParams): boolean {
  const p =
    typeof searchOrParams === 'string' ? new URLSearchParams(searchOrParams) : searchOrParams;
  const adherent = (p.get(DISCOVERY_MFEC_URL_PARAM) || '').trim().toLowerCase();
  if (adherent && TRUTHY.has(adherent)) return true;
  const partner = (p.get('partner') || p.get('partner_slug') || '').trim().toLowerCase();
  return partner === DISCOVERY_MFEC_PARTNER_SLUG;
}

export function setDiscoveryMfecFilter(params: URLSearchParams, active: boolean): void {
  params.delete('partner');
  params.delete('partner_slug');
  if (active) {
    params.set(DISCOVERY_MFEC_URL_PARAM, '1');
  } else {
    params.delete(DISCOVERY_MFEC_URL_PARAM);
  }
}

/** Paramètres API à fusionner quand le filtre est actif. */
export function discoveryMfecFilterApiParams(
  searchOrParams: string | URLSearchParams
): Record<string, string> {
  if (!discoveryMfecFilterActive(searchOrParams)) return {};
  return { [DISCOVERY_MFEC_URL_PARAM]: '1' };
}
